import React from 'react';
import { Col, Grid, Row, Space } from 'antd';
import DeviceCheckDetails from './DeviceCheckDetails';
import DeviceImagesCard from './DeviceImagesCard';
import QuoteActionPanel from './QuoteActionPanel';
import UpdateBidCard from '../historyDetail/UpdateBidCard';
import QuickActionTimer from './QuickActionTimer';

const { useBreakpoint } = Grid;

const QuickActionDetails = ({
  app,
  loadingApp,
  onRejectRequest,
  onDirectAccept,
  bidView = 'new',
  now,
  onUpdateBid,
  onBidUpdated,
}) => {
  const screens = useBreakpoint();
  const isMobile = !screens.sm;

  return (
    <Row gutter={isMobile ? [0, 16] : [24, 24]} style={{ width: '100%' }}>
      <Col xs={24} lg={14} style={{ padding: isMobile ? 0 : '0 12px' }}>
        <DeviceCheckDetails checkDetails={app.checkDetails} />
      </Col>

      <Col xs={24} lg={10} style={{ padding: isMobile ? 0 : '0 12px' }}>
        <Space direction="vertical" size={isMobile ? 'middle' : 'large'} style={{ width: '100%' }}>
          <DeviceImagesCard images={app.images} />
          {now != null && <QuickActionTimer app={app} now={now} />}
          {bidView === 'submitted' ? (
            <UpdateBidCard key={app.id} app={app} now={now} onUpdateBid={onUpdateBid} onBidUpdated={onBidUpdated} />
          ) : (
          <QuoteActionPanel
            app={app}
            loadingApp={loadingApp}
            onRejectRequest={onRejectRequest}
            onDirectAccept={onDirectAccept}
          />
          )}
        </Space>
      </Col>
    </Row>
  );
};

export default QuickActionDetails;
